import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useEverifyAddCompanies() {
  return useMutation({
    mutationFn: async (companies) => {
      const { data } = await api.post("/everifycompany/addcompanies", companies);
      return data;
    },
  });
}
